<template>
  <div class="upload">
  </div>
</template>

<script>
  import $ from 'jquery'
  import WebUploader from 'webuploader'
  import xmail from '@/api/api'
  import md5 from 'js-md5'
  import storeLocal from 'store';
  let fileMd5Map = ""
  export default {
    name: 'vue-upload',
    props: {
      accept: {
        type: Object,
        default: null,
      },
      // 上传地址
      url: {
        type: String,
        default: '/xmail/wm/v1/file/chunkUpload',
      },
      // 上传最大数量 默认为100
      fileNumLimit: {
        type: Number,
        default: 100,
      },
      // 大小限制 默认50M
      // fileSingleSizeLimit: {
      //   type: Number,
      //   default: 50 * 1024 * 1024,
      // },
      // 上传时传给后端的参数
      formData: {
        type: Object,
        default: null
      },
      // 生成formData中文件的key
      // keyGenerator: {
      //   type: Function,
      //   default(file) {
      //     const currentTime = new Date().getTime();
      //     const key = `${currentTime}.${file.name}`;
      //     return key;
      //   },
      // },
      multiple: {
        type: Boolean,
        default: true,
      },
      // 上传按钮ID
      uploadButton: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        uploader: null,
        // userInfo: {userId: '', fileName:'', isChunk:0, chunkIndex:''},   // 用户会话信息
        chunkSize: 2048000,             // 分块大小 (单位：字节)(top.Global.Config.limit.chunkUploadSize)
        // uniqueFileName: null,                  // 文件唯一标识符
        // uniqueFileNameMap: new Map(),
        preFileUrl: null,                      // 文件预览路径
        curChunkState: null,                   // 当前上传分块状态
        realFileName: null,                    // 真实的文件名称
        md5Mark: null,
        urlPref: '',  // 测试线上的url地址
        configSetting: {},
        fileSingleSizeLimit: 50 * 1024 * 1024,
        chunkRetry: 1000,
        largeFileList: []
      };
    },
    mounted() {
      console.log(this.$i18n.t('wm_lang_b90ee1'));
      this.configSetting = storeLocal.get('Pwm-configSetting');
      this.fileSingleSizeLimit = this.configSetting.deliverSetting.maxAttachSizeSingle
        ? this.configSetting.deliverSetting.maxAttachSizeSingle * 1024 * 1024
        : this.fileSingleSizeLimit;
      this.initWebUpload();
    },
    methods: {
      initWebUpload() {
        let _this = this;
        WebUploader.Uploader.register({
          name: 'upload',
          // 在文件发送之前request，此时还没有分片（如果配置了分片的话），可以用来做文件整体md5验证。
          // "before-send-file": "beforeSendFile",
          // 在分片发送之前request，可以用来做分片验证，如果此分片已经上传成功了，可返回一个rejected promise来跳过此分片上传。
          "before-send": "beforeSend"
          // 在所有分片都上传完毕后，且没有错误后request，用来做分片验证，此时如果promise被reject，当前文件上传会触发错误。
          // "after-send-file": "afterSendFile"
        }, {
          beforeSend: function(block){
            if (this.options.name !== 'uploadLarge') {
              let deferred = WebUploader.Deferred();
              let _key = block.file.id + block.file.name + new Date(block.file.lastModifiedDate).valueOf();
              (function (api, enums, pms, block, _key) {
                let fpm = pms.File.chunkCheckParamBuilder();
                // fpm.fileName = _this.uniqueFileName;
                const md5 = JSON.parse(`{${fileMd5Map}}`);
                fpm.fileName = md5[_key];
                // fpm.realFileName = _this.realFileName;
                fpm.realFileName = block.file.name;
                // fpm.isChunk = _this.userInfo.isChunk;
                fpm.isChunk = Math.ceil(block.file.size/_this.chunkSize) > 1 ? 1 : 0;
                fpm.chunkIndex = block.chunk;
                fpm.chunkSize = block.end - block.start;
                api.File.chunkCheck(fpm, function (res) {
                  // console.log(res.data.data);
                  _this.curChunkState = res.status;
                  if(res.data.code === 0) {
                    if(res.data.data.isExist){
                      deferred.reject();
                    }else{
                      deferred.resolve();
                    }
                  } else {
                    deferred.resolve();
                  }
                })
              })(xmail.api, xmail.enums, xmail.pms, block, _key);
              // 分片验证是否已传过，用于断点续传
              return deferred.promise();
            }
          }
        });
        let urlParams = storeLocal.get('Pwm-urlParams');
        this.uploader = WebUploader.create({
          name: 'upload',
          // server: this.getServer("fileUpload"),
          resize: false,  // 尺寸不改变
          compress: false,  // 不启动压缩
          // formData: function(){return $.extend(true, {}, userInfo);},
          auto: false, // 选完文件后，是否自动上传
          swf: '/static/lib/webuploader/Uploader.swf',  // swf文件路径
          server: this.url + urlParams,  // 文件接收服务端
          pick: {
            id: this.uploadButton,     // 选择文件的按钮
            multiple: this.multiple,   // 是否多文件上传 默认false
            label: '',
          },
          dnd: '#dropUploadWrap',
          disableGlobalDnd: true,
          accept: this.getAccept(this.accept),  // 允许选择文件格式。
          threads: 3,
          fileNumLimit: this.fileNumLimit, // 限制上传个数
          // fileSingleSizeLimit: this.fileSingleSizeLimit, // 限制单个上传图片的大小
          formData: this.formData,  // 上传所需参数
          chunked: true,          //分片上传
          chunkSize: 2048000,    //分片大小
          chunkRetry: 3,
          duplicate: true,  // 重复上传
        });

        this.uploader.on('uploadBeforeSend', (block, data) => {
          // console.log(WebUploader);
          let _key = block.file.id + block.file.name + new Date(block.file.lastModifiedDate).valueOf();
          const md5 = JSON.parse(`{${fileMd5Map}}`);
          data.fileName = md5[_key];
          data.isChunk = Math.ceil(block.file.size/_this.chunkSize) > 1 ? 1 : 0;
        });

        // 当有文件被添加进队列的时候，添加到页面预览  第一步
        this.uploader.on('fileQueued', (file) => {
          if (file.size <= this.fileSingleSizeLimit) {
            this.$emit('fileChange', file);
          }
        });
        let largeFileList = [];
        this.uploader.on('beforeFileQueued', (file) => {
          if(file.size <= 0) {
            this.$message({
              type: 'warning',
              message: this.$i18n.t('wm_lang_9c710b')+'0kb'+this.$i18n.t('wm_lang_96ce79')
            });
            return false;
          }

          if (file.size > this.fileSingleSizeLimit) {
            let errorMessage = `${this.$i18n.t('custom_lang_0045')}${this.fileSingleSizeLimit / (1024 * 1024)}M${this.$i18n.t('custom_lang_0046')}`;
            largeFileList.push(file);
            this.uploader.cancelFile(file);
            this.uploader.removeFile(file, true);
            this.$confirm(errorMessage, this.$i18n.t('wm_lang_c45357'), {
              confirmButtonText: this.$i18n.t('wm_lang_06e84a'),
              cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.$emit('openLargeAttach', largeFileList);
              largeFileList = [];
            }).catch(() => {
              largeFileList = [];
            });
            return false;
          }

          let _key = file.id + file.name + new Date(file.lastModifiedDate).valueOf();
          _this.uploader.md5File( file )
          .then(function(val) {
            if (fileMd5Map.indexOf(_key) == -1) {
              fileMd5Map += fileMd5Map.length ? `,"${_key}":"${val}"` : `"${_key}":"${val}"`;
            }
            (function (api, enums, pms) {
              let fpm = pms.File.chunkCheckParamBuilder();
              fpm.fileName = val;
              fpm.realFileName = file.name;
              fpm.isChunk = 0;
              api.File.chunkCheck(fpm, function (res) {
                if(res.data.code === 0) {
                  if(!res.data.data.isExist){
                    _this.uploader.upload(file);
                  }
                  else {
                    // 跳过
                    _this.uploader.skipFile(file);
                    _this.$emit('success', file, {
                      data: {
                        fid: res.data.data.fid,
                        fileName: file.name,
                        fileSizeBytes: file.size
                      }
                    }, {md5: val});
                  }
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          })
        });

        // 文件上传过程中创建进度条实时显示。
        this.uploader.on('uploadProgress', (file, percentage) => {
          this.$emit('progress', file, percentage);
        });
        this.uploader.on('uploadSuccess', (file, response) => {
          let _key = file.id + file.name + new Date(file.lastModifiedDate).valueOf();
          const md5 = JSON.parse(`{${fileMd5Map}}`);
          this.$emit('success', file, response ? response : {
            data: {
              fid: md5[_key],
              fileName: file.name,
              fileSizeBytes: file.size
            }
          }, {md5: md5[_key]});
        });
        this.uploader.on('uploadError', (file, reason) => {
          console.error('reason');
          this.$emit('uploadError', file, reason);
        });
        this.uploader.on('error', (type) => {
          let errorMessage = '';
          if (type === 'Q_EXCEED_NUM_LIMIT') {
            errorMessage = this.$i18n.t('wm_lang_952f2d');
          } else {
            errorMessage = `上传出错！请检查后重新上传！错误代码${type}`;
          }
          // console.error(errorMessage);
          this.$emit('error', errorMessage);
        });
        this.uploader.on('uploadComplete', (file, response) => {
          console.log('uploadComplete');

          this.$emit('complete', file, response);
        });
      },
      upload(file) {
        this.uploader.upload(file);
      },
      stop(file) {
        this.uploader.stop(file);
      },
      // 取消并中断文件上传
      cancelFile(file) {
        this.uploader.cancelFile(file);
      },
      // 在队列中移除文件
      removeFile(file, bool) {
        this.uploader.removeFile(file, bool);
      },
      // dateFormat(date, fmt) {
      //   let o = {
      //     "M+": date.getMonth() + 1, //月份
      //     "d+": date.getDate(), //日
      //     "h+": date.getHours(), //小时
      //     "m+": date.getMinutes(), //分
      //     "s+": date.getSeconds(), //秒
      //     "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      //     "S": date.getMilliseconds() //毫秒
      //   };
      //   if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      //   for (let k in o)
      //     if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      //   return fmt;
      // },
      // getServer(type){
      //   switch(type){
      //     case "fileUpload": return urlPref + "&method=chunkUpload";    // 文件上传
      //     // case "md5Check": return urlPref + "wudemo/wu/md5Check.do";        // 文件MD5验证
      //     case "chunkCheck": return urlPref + "&method=chunkCheck";     // 分块验证
      //     case "chunksMerge": return urlPref + "&method=chunksMerge";   // 分块合并
      //   }
      // },
      getAccept(accept) {
        switch (accept) {
          case 'text':
            return {
              title: 'Texts',
              exteensions: 'doc,docx,xls,xlsx,ppt,pptx,pdf,txt',
              mimeTypes: '.doc,docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt'
            };
            break;
          case 'video':
            return {
              title: 'Videos',
              exteensions: 'mp4',
              mimeTypes: '.mp4'
            };
            break;
          case 'image':
            return {
              title: 'Images',
              exteensions: 'gif,jpg,jpeg,bmp,png',
              mimeTypes: '.gif,.jpg,.jpeg,.bmp,.png'
            };
            break;
          default: return accept
        }
      },
    },
  };
</script>

<style lang="scss">
  .webuploader-container {
    position: relative;
  }
  .webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px,1px,1px,1px);
  }
</style>



// WEBPACK FOOTER //
// src/components/sub/upload.vue